var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersAndSeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10 10 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.183 77.285c14.842-15.874 14.286-40.696-1.252-55.89-15.537-15.193-40.366-15.193-55.903 0C6.49 36.59 5.935 61.411 20.777 77.285c.104.148.23.28.373.39a39.882 39.882 0 0 0 57.66 0c.143-.11.269-.242.373-.39zM49.98 13.593A36.426 36.426 0 0 1 78.205 73.01 31.762 31.762 0 0 0 66.442 60.12a5.064 5.064 0 0 0-5.384.133 19.91 19.91 0 0 1-21.944-.089 5.002 5.002 0 0 0-5.33-.177A31.682 31.682 0 0 0 21.79 73.01a36.426 36.426 0 0 1 28.19-59.418zM24.357 75.88a28.092 28.092 0 0 1 11.23-12.856 1.44 1.44 0 0 1 1.555.098 23.481 23.481 0 0 0 25.862.107 1.466 1.466 0 0 1 1.573-.08 28.128 28.128 0 0 1 11.025 12.73c-14.178 14.086-37.067 14.086-51.245 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.157 60.244a16.711 16.711 0 1 0-16.702-16.702c.014 9.218 7.484 16.688 16.702 16.702zm0-29.86A13.158 13.158 0 1 1 37.01 43.542c.004-7.262 5.887-13.148 13.148-13.158z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersAndSeats);
export default __webpack_public_path__ + "static/media/users-and-seats.f061a47d4e0a2f63bdb6413ae28d9219.svg";
export { ForwardRef as ReactComponent };